import type { ReactElement } from 'react';

import { CreatePasswordScreen } from 'common/accountActivationAndRecovery/CreatePasswordScreen';

import { useDeviceHandoffAccountFlow } from '../hooks/useDeviceHandoffAccountFlow';

export const CreatePasswordRoute = (): ReactElement => (
    <CreatePasswordScreen {...useDeviceHandoffAccountFlow().createPassword} />
);
